import { MARKER_ANCHOR } from 'components/Map/NewJobMarkers/utils/markerConstants';
import { createMarkerPopup } from 'components/Map/NewJobMarkers/utils/markerPopupUtils';
import { createStopPopup } from '../../NewStopMarkers/utils/stopPopupBuilder';
import { createStopTapHandler } from '../../utils/markerTapHandler';

const attachActivityTap = createStopTapHandler((data) => data?.stopIndex);

export function attachActivityHoverEvents(marker, translationsRef, map, dispatch, displayRef) {
  createMarkerPopup(marker, map, MARKER_ANCHOR.STOP.y, (data) =>
    createStopPopup(data, translationsRef.current),
  );
  attachActivityTap(marker, dispatch, displayRef);
}
